import { Component, Input, OnInit } from '@angular/core';
import { NotificationsService } from 'app/notifications';
import { UtilService } from 'app/shared/util.service';

@Component({
    selector: 'mh-core-lib-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
    standalone: false
})
export class CoreLibContentComponent implements OnInit {
  @Input()
  shouldShowHeader: boolean = true;

  @Input()
  disableHeader = false;

  isPaid: boolean;
  isBlocking: boolean;

  constructor(
    private utilService: UtilService,
    private notificationService: NotificationsService
  ) { }

  ngOnInit(): void {
    if (this.utilService.currentUser.isSuperAdmin) return; // Blocking by invoice is not applicable for super admins
    this.isPaid = this.utilService.getIsPaid();
    this.utilService.isPaid().subscribe(paid => {
      this.isPaid = paid;
      const alert = JSON.parse(
        this.notificationService.getResponseAlert()
      );
      const current = this.utilService.getProductByName(
        this.utilService.currentSection
      )
      this.isBlocking = alert[0].products_ids.includes(Number(current)) && alert[0].alert_property_type.name === 'blocking'
    });
  }

}
